import { Component, Input, Output } from '@angular/core';
import { ItemCounterComponent, FocusDirective } from '@spartacus/storefront';
import { EventEmitter } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { KnBrNumbersOnlyDirective } from '../../../../shared/directive/kn-br-numbers-only.directive';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'cwt-cart-item-counter',
    templateUrl: './cwt-cart-item-counter.component.html',
    styleUrl: './cwt-cart-item-counter.component.scss',
    imports: [FocusDirective, ReactiveFormsModule, KnBrNumbersOnlyDirective, TranslatePipe]
})
export class CwtCartItemCounterComponent  extends ItemCounterComponent {
  @Output() emitCount = new EventEmitter()
  @Input() disabled = false;
  override increment(){
   this.control.setValue(this.control.value + this.step);
    this.control.markAsDirty();
    this.emitCount.emit(this.control.value);
  }
    decrement() {
    this.control.setValue(this.control.value - this.step);
    this.control.markAsDirty();
    this.emitCount.emit(this.control.value);
  }

  incrementToValue(changeValue: number) {
      this.control.setValue(changeValue);
      this.control.markAsDirty();
      this.emitCount.emit(this.control.value);
  }


}
